/**
 * Which app a signed-in store gets: a dealership with the dealer workspace switched on gets the dealer workspace
 * (features/dealer, its own shell and routes; every workshop route is closed to it); every other store gets the
 * workshop shell and its routes (`workshop`, from router.tsx), unchanged. Rendered by a splat route, so the routes of
 * either app match the whole path below it.
 */
import { lazy, Suspense } from 'react';
import { useRoutes, type RouteObject } from 'react-router';
import { useSession } from '@app/core/auth';
import { isDealerWorkspace } from '@app/features/dealer/model';
import { Loading } from './Fatal';
import { Shell } from './Shell';

const DealerApp = lazy(() => import('@app/features/dealer'));

export function Workspace({ workshop }: { workshop: RouteObject[] }) {
  const { me } = useSession();
  if (isDealerWorkspace({ segment: me.tenant.segment, flags: me.flags })) {
    return (
      <Suspense fallback={<Loading />}>
        <DealerApp />
      </Suspense>
    );
  }
  return <WorkshopApp routes={workshop} />;
}

function WorkshopApp({ routes }: { routes: RouteObject[] }) {
  return useRoutes([{ element: <Shell />, children: routes }]);
}
